import ControlCard from '@/models/ControlCard/ControlCard';

export default class ControlCardFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.controlCardNumber = '';
		this.id = '';
		this.controlCardTypeId  = '';
		this.controlCardTypeId = '';
		this.controlCardTypeCode = '';
		this.partId = '';
		this.partPartNumber = '';
		this.qtyCase = '';
		this.qtyCaseFrom = '';
		this.qtyCaseTo = '';
		this.areaId = '';
		this.areaCode = '';
		this.rackId = '';
		this.rackCode = '';
		this.docNo = '';
		this.status = '';
		this.receivingDateFrom = '';
		this.receivingDateTo = '';
		this.transactionType = '';
		this.transactionId = '';
		this.revisi = '';
		this.packSequence = '';
		this.totalPack = '';
		this.totalPackFrom = '';
		this.totalPackTo = '';
		this.controlCardStatusId = '';
		this.controlCardStatusName = '';
		this.qcStatusId  = '';
		this.qcStatusName = '';
		this.readyForFinishGoodQualityInspection = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			controlCardNumber : '0',
			id : '0',
			controlCardTypeId : '0',
			controlCardTypeCode : '0',
			partId : '0',
			partPartNumber : '0',
			qtyCase : '0',
			qtyCaseFrom : '0',
			qtyCaseTo : '0',
			areaId : '0',
			areaCode : '0',
			rackId : '0',
			rackCode : '0',
			docNo : '0',
			status : '0',
			receivingDateFrom : '0',
			receivingDateTo : '0',
			transactionType : '0',
			transactionId : '0',
			revisi : '0',
			packSequence : '0',
			totalPack : '0',
			controlCardStatusId : '0',
			controlCardStatusName : '0',
			qcStatusId : '0',
			qcStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			controlCardNumber: '0',
			controlCardTypeId: '0',
			controlCardTypeCode: '0',
			partId: '0',
			partPartNumber: '0',
			qtyCase: '0',
			areaId: '0',
			areaCode: '0',
			rackId: '0',
			rackCode: '0',
			docNo: '0',
			status: '0',
			receivingDateFrom: '0',
			receivingDateTo: '0',
			transactionType: '0',
			transactionId: '0',
			revisi: '0',
			packSequence: '0',
			totalPack: '0',
			controlCardStatusId: '0',
			controlCardStatusName: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}